import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function ServicesSection() {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const services = [{
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path><path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path></svg>,
    title: "Komplettrenovierung",
    description: "Schlüsselfertige Renovierung von Wohnungen und Häusern – alles aus einer Hand."
  }, {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="M3 9h18"></path><path d="M3 15h18"></path><path d="M9 3v18"></path><path d="M15 3v18"></path></svg>,
    title: "Fliesen & Naturstein",
    description: "Verlegung von Fliesen, Mosaik, Marmor, Granit und Naturstein inkl. Untergrundvorbereitung."
  }, {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path><path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path><path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path></svg>,
    title: "Bodenlegerarbeiten",
    description: "Laminat, Parkett, PV, und Estricharbeiten – fachmännisch verlegt."
  }, {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect width="7" height="7" x="3" y="3" rx="1"></rect><rect width="7" height="7" x="14" y="3" rx="1"></rect><rect width="7" height="7" x="14" y="14" rx="1"></rect><rect width="7" height="7" x="3" y="14" rx="1"></rect></svg>,
    title: "Trockenbau & Innenausbau",
    description: "Rigipsdecken, Wandänderungen, Innenwände, Treppen und Badumbau."
  }, {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m14.622 17.897-10.68-2.913"></path><path d="M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z"></path><path d="M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15"></path></svg>,
    title: "Abbruch- & Sanierungsarbeiten",
    description: "Kernbohrungen, Wanddurchbrüche und Demontage, Fachgerechter Rückbau und Entkernung, Schuttentsorgung"
  }, {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path><path d="M3 6h18"></path><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>,
    title: "Abdichtungsarbeiten",
    description: "\xA0Keller- und Fundamentabdichtung (innen & außen) Balkon-, Terrassen- und Flachdachabdichtung Schutz vor Feuchtigkeit und Schimmel"
  }];
  return <section ref={ref} style={{
    backgroundColor: "rgb(245, 240, 235)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 26, 26)",
    fontFamily: 'Inter, "Inter Fallback"',
    paddingTop: "60px",
    paddingBottom: "60px",
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Playfair+Display:wght@700&display=swap');
        .service-card {
          transition: box-shadow 0.3s ease, transform 0.3s ease;
        }
        .service-card:hover {
          box-shadow: rgba(0,0,0,0.12) 0px 8px 24px 0px;
          transform: translateY(-2px);
        }
        .mehr-link {
          transition: color 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .mehr-link:hover {
          color: #a8892e;
        }
        .cta-button {
          transition: opacity 0.2s ease, transform 0.2s ease;
        }
        .cta-button:hover {
          opacity: 0.9;
          transform: scale(1.03);
        }
      `}</style>

      <div className="page-container">
        <div className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex flex-col items-center mb-12">
            <div style={{
            width: "40px",
            height: "2px",
            backgroundColor: "#C8A96E",
            marginBottom: "12px"
          }} />
            <p style={{
            color: "rgb(200, 169, 110)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "20px",
            letterSpacing: "1.4px",
            border: "0px solid rgb(200, 169, 110)",
            textTransform: "uppercase",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "12px"
          }}>
              WAS WIR BIETEN
            </p>
            <h2 style={{
            color: "rgb(26, 26, 26)",
            fontFamily: '"Playfair Display", "Playfair Display Fallback"',
            fontSize: "36px",
            fontWeight: "700",
            lineHeight: "40px",
            border: "0px solid rgb(26, 26, 26)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "16px"
          }}>
              Unser Leistungsspektrum
            </h2>
            <p style={{
            color: "rgb(74, 85, 101)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "24px",
            border: "0px solid rgb(74, 85, 101)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            maxWidth: "600px"
          }}>
              Von der Komplettrenovierung bis zur Entrümpelung – wir decken alle Gewerke ab.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" style={{
          maxWidth: "1280px",
          margin: "0 auto"
        }}>
            {services.map((service, index) => <div key={index} className="service-card" style={{
            backgroundColor: "#FFFFFF",
            borderRadius: "12px",
            padding: "24px",
            boxShadow: "rgba(0,0,0,0.06) 0px 2px 12px 0px",
            transitionDelay: `${index * 80}ms`
          }}>
                <div style={{
              width: "52px",
              height: "52px",
              borderRadius: "50%",
              backgroundColor: "#F5F0EB",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
              color: "#C8A96E",
              flexShrink: 0
            }}>
                  {service.icon}
                </div>
                <h3 style={{
              color: "rgb(26, 26, 26)",
              fontFamily: 'Inter, "Inter Fallback"',
              fontSize: "18px",
              fontWeight: "600",
              lineHeight: "28px",
              border: "0px solid rgb(26, 26, 26)",
              animation: "none 0s ease 0s 1 normal none running",
              marginBottom: "8px"
            }}>
                  {service.title}
                </h3>
                <p style={{
              color: "rgb(74, 85, 101)",
              fontFamily: 'Inter, "Inter Fallback"',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "22.75px",
              border: "0px solid rgb(74, 85, 101)",
              animation: "none 0s ease 0s 1 normal none running",
              marginBottom: "16px"
            }}>
                  {service.description}
                </p>
                <Link to="/ServicesPage" className="mehr-link" style={{
              color: "rgb(200, 169, 110)",
              fontFamily: 'Inter, "Inter Fallback"',
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "20px",
              border: "0px solid rgb(200, 169, 110)",
              animation: "none 0s ease 0s 1 normal none running",
              textDecoration: "none",
              display: "inline-block"
            }}>
                  Mehr erfahren →
                </Link>
              </div>)}
          </div>

          <div className="flex justify-center" style={{
          marginTop: "48px"
        }}>
            <Link to="/ServicesPage" className="cta-button" style={{
            backgroundColor: "#C8A96E",
            color: "#FFFFFF",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: "600",
            borderRadius: "9999px",
            padding: "14px 32px",
            height: "48px",
            minWidth: "239px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "rgba(200, 169, 110, 0.4) 0px 0px 15px 0px",
            textDecoration: "none",
            cursor: "pointer",
            border: "none"
          }}>
              Alle Leistungen ansehen
            </Link>
          </div>
        </div>
      </div>
    </section>;
}